import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import { cards } from '../../../../redux/cards/action';
import {  selectCardQueryItems } from '../../../../redux/cards/selector';
import CardComponent from '../components/card.component';
import * as R from 'ramda';

import { selectCurrent } from '../../../../redux/settings/selectors';
import { settings } from '../../../../redux/settings/actions';
import UploadFiles from '../../../../models/UploadFile';
import PageLoader from '../../../../components/PageLoader';
import { layouts } from '../../../../redux/layouts/action';
import { selectLayoutListItems } from '../../../../redux/layouts/selector';
import { deepCopy, formatLayoutListData, transformBackCardValues, transformCardValues } from '../../../../common/services/common.service';
import storePersist from '../../../../redux/storePersist';
import { selectProductListItems } from '../../../../redux/products/selector';
import { selectCategoriesListItems } from '../../../../redux/categories/selector';
import { products } from '../../../../redux/products/action';
import { categories } from '../../../../redux/categories/action';
let currentChange: any = {}
const LayoutCard= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const routeQuery = useSelector(selectCardQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const layoutLists = useSelector(selectLayoutListItems)
  const { getUploadFiles } = useAppSelector(selectCurrent)
 const [isLoading, setIsLoading] = useState<boolean>(true)
 var tenantId = storePersist?.get("tokenData")?.current?.result?.TokenMetadata?.TenantId;
 const productsData = useSelector(selectProductListItems)
 const categoriesData = useSelector(selectCategoriesListItems)
 const [pageData, setPageData] = useState(1)
 const [pageSize, setPageSize] = useState(10); 
 const [isModalOpen, setIsModalOpen] = useState(false);
 const [isModalProductOpen, setIsProductModalOpen] = useState(false);

 const handleOpenModal = () => setIsModalOpen(true);
 const handleCloseModal = () => setIsModalOpen(false);
 const handleOpenProductModal = () => setIsProductModalOpen(true);
 const handleCloseProductModal = () => setIsProductModalOpen(false);
 const [
  categoryColumnDefs,
  setCategoryColumnDefs
] = useState({});
const createCategoryColumnDefs: any = () => {
  setCategoryColumnDefs([
    {
      field: 'Sl',
      sortable: false,
      filter: false,
      isSortLabel: true,
      headerName: 'Sl',
      cellRenderer (params: any) {
        return parseInt(
          params.node.id,
          10
        ) + 1;
      },
    },
    
    { field: 'CategoryName', headerName: 'Category Name' , isEdit: true},
     { field: 'IsPublished', headerName: 'Published', cellRenderer: 'yesNoRenderer' },
     { field: 'DisplayOrder', headerName: 'Display Order' },
     { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat:true},
     { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat:true } 

  ]);
}

const [
  productColumnDefs,
  setProductColumnDefs
] = useState({});
const createProductColumnDefs: any = () => {
  setProductColumnDefs([
    {
      field: 'Sl',
      sortable: false,
      filter: false,
      isSortLabel: true,
      headerName: 'Sl',
      cellRenderer (params: any) {
        return parseInt(
          params.node.id,
          10
        ) + 1;
      },
    },
    
    {
      field: 'Message.MediaMappings.MediaFiles[0].FileMappingURL',
      headerName: 'Image',
      sortable: false,
      filter: false,
      cellRenderer: 'imageRenderer',
      
    },
    {
      field: 'Message.ProductCode',
      headerName: 'Product Code',
      sortable: true,
      filter: true,
      
    },
    {
      field: 'Message.Name',
      headerName: 'Name',
      sortable: true,
      filter: true,
      isEdit: true,
    },
    { field: 'Message.UOMName', headerName: 'UOM Name', filter: true },
    {
      field: 'Message.Price',
      headerName: 'Price',
      sortable: true,
     isCurrencyValueFormat: true,
    },
    { field: 'Message.StockQuantity', headerName: 'StockQuantity' },
    {
      field: 'Message.IsPublishedInCSP',
      headerName: 'Published In CSP',
      cellRenderer: 'yesNoRenderer',
    },
    {
      field: 'Message.IsPublishedInOpenNetwork',
      headerName: 'Published In OpenNetwork',
      cellRenderer: 'yesNoRenderer',
    },
    {
      field: 'Message.sPublishedInService',
      headerName: 'Published In Service',
      cellRenderer: 'yesNoRenderer',
    },
    {
      field: 'Message.IsAvailable',
      headerName: 'Avilable',
      cellRenderer: 'yesNoRenderer',
    },
    {
      field: 'Message.CreatedOnUtc',
      headerName: 'Created On',
      isDateValueFormat: true,
      sortable: true,
    },

  ]);
}
  const [
    webPageCards,
    setWebPageCards
  ] = useState<any>([]);
  const [
    cardValues,
    setCardValues
  ] = useState<any>([]);
  const [
    cardTemplate,
    setCardTemplate
  ] = useState<any>([]);
  const [
    cardImageIndex,
    setCardImageIndex
  ] = useState<any>([])
  const handleFormChange: any = ({ field, value, idx }: any) => {
    const items = deepCopy(cardValues);// deep copy of WebsiteCard items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setCardValues(items);
  }
 
  const [cardDetailInfo,setCardDetailInfo] = useState([{}])
  const librariesItems = storePersist?.get("library")?.current;
  console.log('librariesItems', librariesItems)
  const entityTypes = librariesItems?.CardType
  

  const handleInnerFormChange: any = (event: any, field: string) => {
    setWebPageCards({ ...webPageCards, [field]: event });
  }
  const fetchRouteById= ()=>{
    dispatch(cards.query({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layout-cards/query`,entity:'cards',jsonData:{     
        Records: [
            {
              
                "context": {},
                "message": {
                    "Id": parmas?.id,
                    "TenantId" : tenantId
                }
            
             
            }
          ]
  
}})).then(()=>{
  setIsQuery(true)
})

  }

  const addNewRow = ({ cardValuesArg }: any) => {
    const localCardValues = deepCopy(cardValuesArg)
    const newsSelectedCards = {
      type: '',
      field: '',
      value: ''
    }
    if (localCardValues.length === 0 ||
        localCardValues[localCardValues?.length - 1]?.type !== ''
    ) {
      localCardValues?.push(newsSelectedCards)
    }

    return localCardValues
  }
  const setCardInfo = async () => {
    let localCardItems = deepCopy(cardValues)
    localCardItems.splice(
      currentChange.idx,
      1,
      { ...localCardItems[currentChange.idx] }
    );
    localCardItems = addNewRow({ cardValuesArg: localCardItems });

    currentChange.field = getIsWebPageCard()
    setCardValues(localCardItems)
  }
  const addNewUpdateCardRow = ({ cardValuesArg }: any) => {
    const localCardValues = deepCopy(cardValuesArg);
    let newCardValueRecord = {};
    
    // Create a new empty row based on the template
    R.map((template: any) => {
      newCardValueRecord = R.assoc(template.field, '', newCardValueRecord);
      return newCardValueRecord;
    })(cardTemplate);
  
    // Get the last row in localCardValues
    const lastRow = localCardValues[localCardValues.length - 1];
  
    // Check if the last row contains 'product' or 'category'
    const hasProductOrCategory = lastRow?.product || lastRow?.category;
  
    // Check if the last row is filled with any other data
    const isLastRowFilledWithData = R.any(R.complement(R.isEmpty))(R.values(lastRow));
  
    // Add a new empty row only if there's no product or category in the last row
    if (localCardValues.length === 0 || (isLastRowFilledWithData && !hasProductOrCategory)) {
      localCardValues.push(newCardValueRecord);
    }
  
    return localCardValues;
  }
  const setUpdateCardInfo = async () => {
    let localCardItems = deepCopy(cardValues)
    localCardItems.splice(
      currentChange.idx,
      1,
      { ...localCardItems[currentChange.idx] }
    );
    localCardItems = addNewUpdateCardRow({ cardValuesArg: localCardItems });

    currentChange.field = getIsWebPageCard()
    setCardValues(localCardItems)
  }

  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);
  const changeCardFile = (idx: number, templateField: any, fileType: any) => {
    setCardImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: cardValues[idx][templateField],
      folder: 'website',
      type: fileType
    })
    currentChange = { idx, templateField }
  }

  const handleSubmit = (data: any) => {
    cardValues[cardImageIndex][currentChange.templateField] = data
    const localSelectedMedia = addNewRow({ cardValuesArg: cardValues });
    setCardValues(localSelectedMedia)
  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))
    
  }

  const typeData = [
    { value: 'text', text: 'Text' },
    { value: 'rte', text: 'TextLong' },
    { value: 'email', text: 'Email' },
    { value: 'number', text: 'Number' },
    { value: 'checkbox', text: 'Checkbox' },
    { value: 'image', text: 'Image' },
    { value: 'video', text: 'Video' },
    { value: 'product', text: 'Product' },
    { value: 'category', text: 'Category' }
  ]
  
  useEffect(
    () => {
        const localCard = addNewRow({ cardValuesArg: cardValues })
        setCardValues(localCard)
        dispatch(layouts.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layouts/list`,entity:'layouts',jsonData:{}}))
        .then(() => {
        dispatch(products.list({
          url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/catalog/products/list`,
          entity: 'products',
          jsonData: {"PageNumber": pageData,
              "PageSize": pageSize,
              "SortField": "Id",
              "SortOrder": "desc",}
      }))})
      .then(() => {
        dispatch(categories.list({
          url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/catalog/categories/list`,
          entity: 'categories',
          jsonData: {"PageNumber": pageData,
              "PageSize": pageSize,
              "SortField": "Id",
              "SortOrder": "desc",}
      }))})
      createCategoryColumnDefs()
      createProductColumnDefs()
      if (parmas?.id > 0) {
        fetchRouteById()
        setIsLoading(false)
      }
      else{
        setIsLoading(false)
      }
    },
    [pageData,pageSize]
  )
  useEffect(
    () => {
        
      if (isQuery) {
        const clonedItems = JSON.parse(JSON.stringify(routeQuery?.result?.items));
      setWebPageCards(clonedItems);
        const parsedCardValue = JSON.parse(clonedItems?.CardValue);
        if (clonedItems?.CardTypeId!== 0 && clonedItems?.CardTypeId!== 10) {
          setCardDetailInfo({ ...parsedCardValue });
        }
        // else if (clonedItems?.CardTypeId!== 0 && clonedItems?.CardTypeId!== 10 && clonedItems?.CardTypeId=== 40) {
        //       setCardDetailInfo([ ...parsedCardValue ]);
        //   }
      else{
      setCardTemplate(JSON.parse(routeQuery?.result?.items?.CardValue)[0])
   
      const localCard = addNewUpdateCardRow({ cardValuesArg: transformCardValues(JSON.parse(routeQuery?.result?.items?.CardValue)) })
      setCardValues(localCard)
      }
        
      }
    },
    [isQuery]
  )
  
  useEffect(
    () => {
      if (currentChange.field && parmas?.id == 0) {
        setCardInfo()
      }
      if (currentChange.field && parmas?.id > 0) {
        setUpdateCardInfo()
      }
    },
    [cardValues]
  )
  const getIsWebPageCard = () => currentChange.field === 'type'


  const handleCollectionsCardDelete = async () =>{
    if(parmas?.id >0){
      const backTransformedCard = transformBackCardValues(JSON.stringify(cardValues))
      dispatch(cards.update({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layout-cards`,entity:'cards',jsonData:{
           
      Records: [
        {
          context: {},
          message: {
            Id: webPageCards?.Id,
            PlatformWebSiteLayoutId: webPageCards?.PlatformWebSiteLayoutId,
            CardName: webPageCards?.CardName,
            CardVersionId: webPageCards?.CardVersionId,
            CardTypeId: webPageCards.CardTypeId ||0 ,
            CardValue: backTransformedCard,
            Remarks: webPageCards?.Remarks,
            TenantId: tenantId
          }
        }
      ]
  
 }})).then(()=>{
  back()
})
 

    }
    else{
      const card = deepCopy(cardValues)
      setCardValues(card)
    }
  }
  const deletewebPageCardItem = async (Item: any, index: any) => {
    if(!selectedRows){
      handleCollectionsCardDelete()
    }
    else if(parmas.id >0){
      const card = deepCopy(cardValues)
     
    card.splice(
      index,
      1
    )
      const backTransformedCard = transformBackCardValues(JSON.stringify(card))
      dispatch(cards.update({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layout-cards`,entity:'cards',jsonData:{
           
      Records: [
        {
          context: {},
          message: {
            Id: webPageCards?.Id,
            PlatformWebSiteLayoutId: webPageCards?.PlatformWebSiteLayoutId,
            CardName: webPageCards?.CardName,
            CardVersionId: webPageCards?.CardVersionId,
            CardTypeId: webPageCards.CardTypeId ||0 ,
            CardValue: backTransformedCard,
            Remarks: webPageCards?.Remarks,
            TenantId: tenantId
          }
        }
      ]
  
 }})).then(()=>{
  back()
})
 

    }
    else{
      const card = deepCopy(cardValues)
      card.splice(
        index,
        1
      )
      setCardValues(card)
    }

  }
 
 const handleCollectionsCard = async () =>{
  if (parmas?.id > 0 ) {
    await dispatch(cards.resetAction({ actionType: 'update' }))
    const backTransformedCard = transformBackCardValues(JSON.stringify(cardValues))
    await dispatch(cards.update({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layout-cards`,entity:'cards',jsonData:{
         
    Records: [
      {
        context: {},
        message: {
          Id: webPageCards?.Id,
          PlatformWebSiteLayoutId: webPageCards?.PlatformWebSiteLayoutId,
          CardName: webPageCards?.CardName,
          CardVersionId: webPageCards?.CardVersionId,
          CardTypeId: webPageCards?.CardTypeId ||0,
          CardValue: backTransformedCard,
          Remarks: webPageCards?.Remarks,
          TenantId: tenantId
        }
      }
    ]

}})).then(()=>{
back()
})

   }else{
    await dispatch(cards.resetAction({ actionType: 'create' }))
  const selectedCards = cardValues.map((item: any) => {
    const cardValueData = {
      field: item?.field,
      value: item?.value,
      type: item?.type
    }
    return cardValueData
  })

  const backTransformedCard = JSON.stringify([selectedCards])
  await dispatch(cards.create({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layout-cards`,entity:'cards',jsonData:{
        
    Records: [
      {
      
        "context": {},
        "message": {
          Id: 0,
          PlatformWebSiteLayoutId: webPageCards?.PlatformWebSiteLayoutId,
          CardName: webPageCards.CardName,
          CardValue: backTransformedCard,
          CardVersionId: 0,
          CardTypeId: webPageCards.CardTypeId ||0 ,
          Remarks: 'string',
          TenantId: tenantId
        }
    }
    ]
  
}})).then(()=>{
  back()
})

   }


 }

const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (webPageCards?.CardTypeId !== 10 && webPageCards?.CardTypeId!==0 ){
      if (parmas?.id > 0 ) {
        await dispatch(cards.resetAction({ actionType: 'update' }))
          const cardDetailInfoCopy = _.cloneDeep(webPageCards.cardDetailInfo);
          await dispatch(cards.update({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layout-cards`,entity:'cards',jsonData:{
             
        Records: [
          {
            context: {},
            message: {
              Id: webPageCards?.Id,
              PlatformWebSiteLayoutId: webPageCards?.PlatformWebSiteLayoutId,
              CardName: webPageCards?.CardName,
              CardVersionId: webPageCards?.CardVersionId,
              CardTypeId: webPageCards.CardTypeId ||0 ,
              CardValue: JSON.stringify(cardDetailInfoCopy),
              Remarks: webPageCards?.Remarks,
              TenantId: tenantId
            }
          }
        ]
    
    }})).then(()=>{
    back()
    })
     }
       // if loop for handling categories 
       else if (webPageCards?.CardTypeId === 80){
        const selectedCards = cardValues.map((item: any) => {
          const cardValueData = {
            field: item?.field,
            value: [item?.value],
            type: item?.type
          }
          return cardValueData
        })
        const backTransformedCard = JSON.stringify(selectedCards)
     await dispatch(cards.resetAction({ actionType: 'create' }))
        await dispatch(cards.create({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layout-cards`,entity:'cards',jsonData:{ 
        Records: [
          {
          
            "context": {},
            "message": {
              Id: 0,
              PlatformWebSiteLayoutId: webPageCards?.PlatformWebSiteLayoutId,
              CardName: webPageCards.CardName,
              CardValue: backTransformedCard,
              CardVersionId: 0,
              CardTypeId: webPageCards.CardTypeId ||0 ,
              Remarks: 'string',
              TenantId: tenantId
            }
        }
        ]
      
    }})).then(()=>{
      back()
    })
       }else{
        await dispatch(cards.resetAction({ actionType: 'create' }))
        await dispatch(cards.create({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layout-cards`,entity:'cards',jsonData:{ 
        Records: [
          {
          
            "context": {},
            "message": {
              Id: 0,
              PlatformWebSiteLayoutId: webPageCards?.PlatformWebSiteLayoutId,
              CardName: webPageCards.CardName,
              CardValue: JSON.stringify(webPageCards.cardDetailInfo),
              CardVersionId: 0,
              CardTypeId: webPageCards.CardTypeId ||0 ,
              Remarks: 'string',
              TenantId: tenantId
            }
        }
        ]
      
    }})).then(()=>{
      back()
    })
    
       }
    }
    else{
    const card = deepCopy(cardValues)
    card.splice(
      card.length - 1,
      1
    )
    if(selectedRows){
      handleCollectionsCard()
     }
    else if (parmas?.id > 0 ) {
      await dispatch(cards.resetAction({ actionType: 'update' }))
      const backTransformedCard = transformBackCardValues(JSON.stringify(card))
      await  dispatch(cards.update({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layout-cards`,entity:'cards',jsonData:{
           
        Records: [
          {
            context: {},
            message: {
              Id: webPageCards?.Id,
              PlatformWebSiteLayoutId: webPageCards?.PlatformWebSiteLayoutId,
              CardName: webPageCards?.CardName,
              CardVersionId: webPageCards?.CardVersionId,
              CardTypeId: webPageCards.CardTypeId ||0 ,
              CardValue: backTransformedCard,
              Remarks: webPageCards?.Remarks,
              TenantId: tenantId
            }
          }
        ]
 }})).then(()=>{
  back()
})
 
 
     }else{
    const selectedCards = card.map((item: any) => {
      const cardValueData = {
        field: item?.field,
        value: item?.value,
        type: item?.type
      }
      return cardValueData
    })

    const backTransformedCard = JSON.stringify([selectedCards])
    await dispatch(cards.resetAction({ actionType: 'create' }))
    await dispatch(cards.create({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layout-cards`,entity:'cards',jsonData:{
          
        Records: [
          {
          
            "context": {},
            "message": {
              Id: 0,
              PlatformWebSiteLayoutId: webPageCards?.PlatformWebSiteLayoutId,
              CardName: webPageCards.CardName,
              CardValue: backTransformedCard,
              CardVersionId: 0,
              CardTypeId: webPageCards.CardTypeId ||0 ,
              Remarks: 'string',
              TenantId: tenantId
            }
        }
        ]
    
  }})).then(()=>{
    back()
  })

     }
    }
  }

const back=()=>{
  navigate(`/web-platform/cards`)
} 
const handleEdit=(data: any)=>{
    navigate(`${data?.Message?.Id}`)
   }
   const [selectedRows, setSelectedRows] = useState<any[]>([]);
   const handleRowSelection = (row: any, checked: boolean) => {
    if (checked) {
      setSelectedRows((prev) => [...prev, row]);
    } else {
      setSelectedRows((prev) => prev.filter((item) => item !== row));
    }
  };

  const transformCardValueForCreateProduct = (selectedRows: any) => {
    return [
      {
          type: "product",
          field: "product",
          value: selectedRows[0]
      },
      {
          type: "text",
          field: "id",
          value: selectedRows[0]?.Message?.Id || ''
      },
      {
          type: "text",
          field: "name",
          value: selectedRows[0]?.Message?.Name ||''
      },
      {
          type: "text",
          field: "code",
          value: selectedRows[0]?.Message?.ProductCode ||''
      },
      {
        type: "text",
        field: "price",
        value: selectedRows[0]?.Message?.Price ||''
    },
    {
      type: "text",
      field: "description",
      value: selectedRows[0]?.Message?.Description ||''
  },
  {
    type: "image",
    field: "src",
    value: selectedRows[0].Message.MediaMappings.MediaFiles[0]?.FileMappingURL || ''
},
{
  type: "text",
  field: "vendorName",
  value: selectedRows[0]?.Message?.VendorName ||''
},
{
type: "text",
field: "productCombinationId",
value: selectedRows[0]?.Message?.Id || ''
}
  ];
  }
  const transformCardValueForCreateCategory = (selectedRows: any) => {
    // Ensure selectedRows is an array
    if (Array.isArray(selectedRows) && selectedRows.length > 0) {
      // Map through selectedRows to create a transformed version
      const transformedRow = {
        ...selectedRows[0], // Copy all properties
        Id: 0, // Replace `id` with `0`
      };
  
      return [
        {
          type: "text",
          field: "category",
          value: transformedRow,
        },
      ];
    }
  
    // Fallback if selectedRows is empty or not an array
    return [];
  };
  const handleAddCollections = () => {
    
if (selectedRows[0]?.Message?.ProductCode && parmas?.id == 0){
  const updatedCardValues = transformCardValueForCreateProduct(selectedRows);
  setCardValues(updatedCardValues);
  handleCloseProductModal()
}
if((selectedRows[0]?.CategoryName || selectedRows[0]?.CategoryCode) && parmas?.id == 0){
  const updatedCardValues = transformCardValueForCreateCategory(selectedRows);
  setCardValues(updatedCardValues);
  handleCloseModal()
   }
    if(selectedRows[0]?.Message?.ProductCode && parmas?.id> 0){
     
   const updatedCardValues = transformCardValue(selectedRows, cardTemplate);
   setCardValues(updatedCardValues);
  
   handleCloseProductModal()
    }
    if((selectedRows[0]?.CategoryName || selectedRows[0]?.CategoryCode) && parmas?.id> 0){
      const updatedCardValues = transformCardValueCategory(selectedRows, cardTemplate);
      setCardValues(updatedCardValues);
      handleCloseModal()
       }

  };

  const transformCardValueCategory = (selectedRows: any[], cardTemplate: any[]): any[] => {
    return selectedRows.map(row => {
      const transformedCard: any = {};
      cardTemplate.forEach(template => {
        const field = template.field;
        if (field === 'src' && row?.MediaMappings?.MediaFiles?.length) {
          transformedCard[field] = row.MediaMappings.MediaFiles[0]?.FileMappingURL || '';
        } 
        else if(field === 'id'|| field ==='categoryId')
          {
            transformedCard[field] = row?.Id || '';
          }
          else if (field === 'name'||field ==='categoryName') {
          transformedCard[field] = row?.Name || '';
        } else if (field === 'code'|| field=== 'categoryCode') {
          transformedCard[field] = row?.CategoryCode || '';
        } else if (field === 'price') {
          transformedCard[field] = row?.Price || '';
        } else if (field === 'description') {
          transformedCard[field] = row?.Description || '';
        } else if (field === 'category') {
          transformedCard[field] = row
        } else {
          transformedCard[field] = '';
        }
      });
  
      return transformedCard;

    });
    
  };

  const transformCardValue = (selectedRows: any[], cardTemplate: any[]): any[] => {
    return selectedRows.map(row => {
      const transformedCard: any = {};
      const message = row?.Message || {};
      cardTemplate.forEach(template => {
        const field = template.field;
        if (field === 'src' && message?.MediaMappings?.MediaFiles?.length) {
          transformedCard[field] = message.MediaMappings.MediaFiles[0]?.FileMappingURL || '';
        } 
        else if(field === 'id'|| field ==='productId')
          {
            transformedCard[field] = message?.Id || '';
          }
        else if (field === 'name' || field ==='productName') {
          transformedCard[field] = message?.Name || '';
        } else if (field === 'code' || field ==='productCode') {
          transformedCard[field] = message?.ProductCode || '';
        } else if (field === 'price') {
          transformedCard[field] = message?.Price || '';
        }
        else if ((field === 'productCombinationId'|| 'combinationId') && message?.ProductAttributeCombinations) {
          transformedCard[field] = message?.ProductAttributeCombinations?.ProductAttributeCombinationId || '';
        }
        else if (field === 'vendorName') {
          transformedCard[field] = message?.VendorName || '';
        }  else if (field === 'description') {
          transformedCard[field] = message?.Description || '';
        } else if (field === 'product') {
          transformedCard[field] = row
        } else {
          // transformedCard[field] = '';
        }
      });
  
      return transformedCard;

    });
    
  };
 


  const additionButtons: any = [
    {
      name: 'Add Collection',
      callback: () => handleAddCollections(),
    }
  ];


    return (
    <>
      {getUploadFiles == 'open' && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
    folder={openFile?.folder}
         handleClose={handleClose}
         handleFilesSubmit={handleSubmit}
         type={openFile?.type}
         ownerId={parmas?.id}
         tenantId={tenantId}
         />}
    {isLoading ? <PageLoader /> : 
          <CardComponent 
           handleFormChange={handleFormChange}
           webPageCards={webPageCards}
           back={back}
           handleFormSubmit={handleFormSubmit}
           id={parmas?.id}
           cardValues={cardValues}
           onEdit={handleEdit}
           typeData={typeData}
           cardTypes={entityTypes}
           layouts={formatLayoutListData(layoutLists?.result?.items)}
           deletewebPageCardItem={deletewebPageCardItem}
           cardTemplate ={cardTemplate}
           changeCardFile={changeCardFile}
           handleInnerFormChange={handleInnerFormChange}
           products={productsData?.result?.items}
           categories={categoriesData?.result?.items}
           categoryColumnDefs={categoryColumnDefs}
           setPageData={setPageData}
           categoriesPaginationData={categoriesData?.result?.pagination}
           productsPaginationData={productsData?.result?.pagination}
           productColumnDefs={productColumnDefs}
           setPageSize={setPageSize}
           onSelect={handleRowSelection}
           additionButtons={additionButtons}
           isModalOpen={isModalOpen}
           isModalProductOpen={isModalProductOpen}
           handleOpenModal ={handleOpenModal}
           handleCloseModal ={handleCloseModal}
           handleOpenProductModal ={handleOpenProductModal}
           handleCloseProductModal ={handleCloseProductModal}
           cardDetailInfo={cardDetailInfo}
          />  
        }
    
        </>
  )
  
  }
   
    export default LayoutCard;